/* BM CART — shared logic for the cart page and the cart drawer.
   Renders through the Section Rendering API so prices, discounts and money
   formatting always come from Liquid (no client-side price maths). */
(function () {
  'use strict';
  if (window.__bmCartReady) return;
  window.__bmCartReady = true;

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var drawer = document.getElementById('ltn__utilize-cart-menu');
  var isCartPage = !!document.querySelector('[data-bm-cart-root][data-context="page"]');

  function roots() { return $$('[data-bm-cart-root]'); }
  function sectionIds() {
    return roots().map(function (r) { return r.getAttribute('data-section-id'); }).filter(Boolean);
  }
  function setBusy(on) { roots().forEach(function (r) { r.classList.toggle('is-busy', !!on); }); }

  function showError(msg) {
    roots().forEach(function (r) {
      var el = r.querySelector('[data-bm-error]');
      if (!el) return;
      el.textContent = msg || 'Something went wrong. Please try again.';
      el.hidden = false;
      clearTimeout(el._bmT);
      el._bmT = setTimeout(function () { el.hidden = true; }, 6000);
    });
  }

  /* Header counters used by the theme (.bigcounter, .shopping-cart__total) */
  function updateHeader(count, totalHtml) {
    $$('.bigcounter').forEach(function (el) { el.textContent = count; });
    if (totalHtml) $$('.shopping-cart__total').forEach(function (el) { el.innerHTML = totalHtml; });
  }

  var lastMeta = null;
  function readMeta(scope) {
    var m = (scope || document).querySelector('[data-bm-meta]');
    if (!m) return null;
    return {
      count: parseInt(m.getAttribute('data-count'), 10) || 0,
      code: m.getAttribute('data-code') || '',
      codeOn: m.getAttribute('data-code-on') === 'true',
      threshold: parseInt(m.getAttribute('data-threshold'), 10) || 2,
      total: m.getAttribute('data-total') || ''
    };
  }

  function applySections(sections) {
    if (!sections) return;
    var meta = null;
    roots().forEach(function (root) {
      var html = sections[root.getAttribute('data-section-id')];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-bm-region]', root).forEach(function (region) {
        var fresh = doc.querySelector('[data-bm-region="' + region.getAttribute('data-bm-region') + '"]');
        if (fresh) region.innerHTML = fresh.innerHTML;
      });
      var m = readMeta(doc);
      if (m) {
        meta = m;
        root.setAttribute('data-empty', m.count === 0 ? 'true' : 'false');
      }
    });
    if (meta) {
      lastMeta = meta;
      updateHeader(meta.count, meta.total);
      maybeApplyOfferCode(meta);
    }
    document.dispatchEvent(new CustomEvent('bm:cart:updated', { detail: meta }));
  }

  /* Auto-apply the multi-buy discount code once the item threshold is reached */
  var codeTriedAt = {};
  function maybeApplyOfferCode(meta) {
    if (!meta || !meta.code || meta.codeOn || meta.count < meta.threshold) return;
    if (codeTriedAt[meta.count]) return;
    codeTriedAt[meta.count] = true;
    run(function () { return postJSON('/cart/update.js', withSections({ discount: meta.code })); });
  }

  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = '/cart'; }
    return body;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.description || j.message || 'Something went wrong. Please try again.');
          e.data = j;
          throw e;
        }
        return j;
      });
    });
  }

  function fetchSections() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch('/cart?sections=' + encodeURIComponent(ids.join(',')), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applySections);
  }

  /* Serialise cart requests so rapid clicks never race */
  var queue = Promise.resolve();
  function enqueue(fn) {
    queue = queue.catch(function () {}).then(fn);
    return queue;
  }

  function run(request) {
    setBusy(true);
    return enqueue(function () {
      return request()
        .then(function (res) {
          if (res && res.sections) applySections(res.sections);
          else return fetchSections().then(function () { return res; });
          return res;
        })
        .catch(function (err) {
          showError(err && err.message);
          return fetchSections().catch(function () {});
        });
    }).then(function (res) { setBusy(false); return res; }, function () { setBusy(false); });
  }

  function refresh() {
    setBusy(true);
    return enqueue(fetchSections).then(function () { setBusy(false); }, function () { setBusy(false); });
  }

  function changeLine(key, qty) {
    return run(function () { return postJSON('/cart/change.js', withSections({ id: key, quantity: qty })); });
  }
  function addItems(items) {
    return run(function () { return postJSON('/cart/add.js', withSections({ items: items })); });
  }
  function swapVariant(key, newId, qty) {
    /* Add the new size first so a stock error leaves the original line untouched */
    return run(function () {
      return postJSON('/cart/add.js', { items: [{ id: newId, quantity: qty }] })
        .then(function () { return postJSON('/cart/change.js', withSections({ id: key, quantity: 0 })); });
    });
  }

  /* Quantity steppers — optimistic number, debounced request */
  var pending = {};
  function bumpQty(btn, delta) {
    var key = btn.getAttribute('data-key');
    var wrap = btn.closest('[data-bm-qty]');
    var out = wrap && wrap.querySelector('[data-bm-qty-value]');
    if (!out) return;
    var next = Math.max(0, (parseInt(out.textContent, 10) || 0) + delta);
    $$('.bm-item[data-key="' + key + '"] [data-bm-qty-value]').forEach(function (el) { el.textContent = next; });
    clearTimeout(pending[key]);
    pending[key] = setTimeout(function () { delete pending[key]; changeLine(key, next); }, 350);
  }

  /* Drawer open / close — same classes the theme's main.js uses */
  function openCart(skipFetch) {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.classList.add('ltn__utilize-open');
    document.body.classList.add('ltn__utilize-open');
    if (window.jQuery) window.jQuery('.ltn__utilize-overlay').fadeIn();
    if (skipFetch !== true) refresh();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('ltn__utilize-open');
    document.body.classList.remove('ltn__utilize-open');
    if (window.jQuery) window.jQuery('.ltn__utilize-overlay').fadeOut();
  }

  /* Pincode → estimated delivery window (business days, Sundays skipped) */
  function addDays(n) {
    var d = new Date(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; }
    return d;
  }
  function fmtDate(d) {
    try { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (_) { return d.toDateString(); }
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-bm-minus]'))) { e.preventDefault(); bumpQty(t, -1); return; }
    if ((t = e.target.closest('[data-bm-plus]'))) { e.preventDefault(); bumpQty(t, 1); return; }
    if ((t = e.target.closest('[data-bm-remove]'))) {
      e.preventDefault();
      var k = t.getAttribute('data-key');
      clearTimeout(pending[k]); delete pending[k];
      changeLine(k, 0);
      return;
    }
    if ((t = e.target.closest('[data-bm-change-toggle]'))) {
      e.preventDefault();
      var item = t.closest('.bm-item');
      var swap = item && item.querySelector('[data-bm-swap]');
      if (!swap) return;
      var open = swap.hidden;
      swap.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.textContent = open ? 'Cancel' : 'Change';
      if (open) { var sel = swap.querySelector('select'); if (sel) sel.focus(); }
      return;
    }
    if ((t = e.target.closest('[data-bm-upsell-add]'))) {
      e.preventDefault();
      var vid = t.getAttribute('data-variant-id');
      if (vid) {
        t.disabled = true; t.textContent = 'Adding…';
        addItems([{ id: parseInt(vid, 10), quantity: 1 }]);
      } else {
        var card = t.closest('.bm-up');
        var sizes = card && card.querySelector('[data-bm-sizes]');
        if (!sizes) return;
        sizes.hidden = !sizes.hidden;
        t.setAttribute('aria-expanded', sizes.hidden ? 'false' : 'true');
        t.hidden = !sizes.hidden;
        if (!sizes.hidden) { var first = sizes.querySelector('.bm-size:not([disabled])'); if (first) first.focus(); }
      }
      return;
    }
    if ((t = e.target.closest('[data-bm-size]'))) {
      e.preventDefault();
      if (t.disabled) return;
      t.disabled = true;
      addItems([{ id: parseInt(t.getAttribute('data-bm-size'), 10), quantity: 1 }]);
      return;
    }
    if ((t = e.target.closest('a.ltn__utilize-toggle[href="#ltn__utilize-cart-menu"]'))) {
      refresh(); /* theme main.js opens the drawer; we make sure it is current */
      return;
    }
    if ((t = e.target.closest('[data-bm-close]'))) {
      if (!isCartPage) closeCart();
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-bm-variant-select]');
    if (!s) return;
    swapVariant(s.getAttribute('data-key'), parseInt(s.value, 10), parseInt(s.getAttribute('data-qty'), 10) || 1);
  });

  /* Pincode lookup — India Post directory (api.postalpincode.in), shared by the drawer and the cart page.
     The API confirms the pincode exists and where it is; it does NOT confirm courier serviceability. */
  var PIN_API = 'https://api.postalpincode.in/pincode/';
  var pinCache = {};
  try { pinCache = JSON.parse(sessionStorage.getItem('bm:pincache') || '{}') || {}; } catch (_) { pinCache = {}; }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lookupPin(pin) {
    if (pinCache[pin]) return Promise.resolve(pinCache[pin]);
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
    return fetch(PIN_API + pin, ctl ? { signal: ctl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        clearTimeout(timer);
        var row = Array.isArray(data) ? data[0] : null;
        if (!row || !row.Status) throw new Error('Bad response');
        var res;
        if (row.Status === 'Success' && row.PostOffice && row.PostOffice.length) {
          var offices = row.PostOffice;
          var po = offices.filter(function (o) { return o.DeliveryStatus === 'Delivery'; })[0] || offices[0];
          res = { ok: true, area: po.Name || '', district: po.District || '', state: po.State || '' };
        } else {
          res = { ok: false };
        }
        pinCache[pin] = res;
        try { sessionStorage.setItem('bm:pincache', JSON.stringify(pinCache)); } catch (_) {}
        return res;
      }, function (err) { clearTimeout(timer); throw err; });
  }

  function windowText(form) {
    var min = parseInt(form.getAttribute('data-min'), 10) || 3;
    var max = Math.max(min, parseInt(form.getAttribute('data-max'), 10) || 6);
    return fmtDate(addDays(min)) + ' – ' + fmtDate(addDays(max));
  }

  function renderPin(form, msg, pin, res) {
    msg.classList.remove('is-error', 'is-ok');
    if (res === 'invalid') {
      msg.textContent = 'Please enter a valid 6-digit pincode.';
      msg.classList.add('is-error');
      return;
    }
    if (res === 'loading') {
      msg.innerHTML = 'Checking <strong>' + esc(pin) + '</strong>…';
      return;
    }
    if (res && res.ok) {
      var place = [res.district, res.state].filter(Boolean).join(', ');
      msg.classList.add('is-ok');
      msg.innerHTML = 'Delivering to <strong>' + esc(place || pin) + '</strong> (' + esc(pin) + ')<br>Estimated delivery: <strong>' + windowText(form) + '</strong>';
      return;
    }
    if (res && res.ok === false) {
      msg.textContent = 'We couldn’t find pincode ' + pin + '. Please check it and try again.';
      msg.classList.add('is-error');
      return;
    }
    /* API unreachable / timed out — still give an estimate, without the location */
    msg.innerHTML = 'Estimated delivery to <strong>' + esc(pin) + '</strong>: <strong>' + windowText(form) + '</strong>';
  }

  /* Run a lookup and mirror the result into every pincode block on the page (drawer + cart page) */
  function checkPin(pin, sourceForm) {
    var forms = $$('[data-bm-pin-form]');
    function each(fn) {
      forms.forEach(function (f) {
        var m = f.parentNode.querySelector('[data-bm-pin-msg]');
        var i = f.querySelector('input');
        if (m) fn(f, m, i);
      });
    }
    if (!/^[1-9]\d{5}$/.test(pin)) {
      if (sourceForm) {
        var m0 = sourceForm.parentNode.querySelector('[data-bm-pin-msg]');
        renderPin(sourceForm, m0, pin, 'invalid');
        sourceForm.querySelector('input').focus();
      }
      return Promise.resolve();
    }
    each(function (f, m, i) { i.value = pin; f.setAttribute('aria-busy', 'true'); f.querySelector('button').disabled = true; renderPin(f, m, pin, 'loading'); });
    try { localStorage.setItem('bm:pincode', pin); } catch (_) {}
    return lookupPin(pin)
      .then(function (res) { return res; }, function () { return null; })
      .then(function (res) {
        each(function (f, m) { f.removeAttribute('aria-busy'); f.querySelector('button').disabled = false; renderPin(f, m, pin, res); });
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-bm-pin-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input');
    var v = String(input.value || '').replace(/\D/g, '');
    input.value = v;
    checkPin(v, f);
  });

  /* Remembered pincode: prefill everywhere; look it up on the cart page, and on the first drawer open elsewhere */
  var savedPin = null;
  try { savedPin = localStorage.getItem('bm:pincode'); } catch (_) {}
  if (savedPin && /^[1-9]\d{5}$/.test(savedPin)) {
    $$('[data-bm-pin-form] input').forEach(function (i) { i.value = savedPin; });
    if (isCartPage) {
      checkPin(savedPin);
    } else if (drawer) {
      var pinObs = new MutationObserver(function () {
        if (drawer.classList.contains('ltn__utilize-open')) { pinObs.disconnect(); checkPin(savedPin); }
      });
      pinObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* "Our kind of people" marquee: rendered by sections/bm-cart-proof.liquid (header group), moved into the drawer slot */
  function mountProof() {
    var slot = drawer && drawer.querySelector('[data-bm-proof-slot]');
    var src = document.querySelector('[data-bm-proof]:not([data-bm-proof-mounted])');
    if (!slot || !src) return;
    slot.innerHTML = '';
    src.setAttribute('data-bm-proof-mounted', '');
    slot.appendChild(src);
    src.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountProof);
  else mountProof();
  document.addEventListener('shopify:section:load', mountProof);

  /* Events from product page, product cards and quick view */
  document.addEventListener('cart:add', function (e) {
    var d = e.detail || {};
    if (!d.id) return;
    addItems([{ id: parseInt(d.id, 10), quantity: parseInt(d.qty, 10) || 1 }])
      .then(function () { if (!isCartPage) openCart(true); });
  });
  document.addEventListener('cart:refresh', function () { refresh(); });

  /* Hook the theme's cart API (assets/cart.api.js) so every theme add/remove refreshes our UI */
  function hookTheme() {
    if (!window.Shopify) return;
    window.Shopify.onCartUpdate = function (cart) {
      if (cart) updateHeader(cart.item_count);
      refresh();
    };
  }
  /* cart.api.js loads later (deferred), so hook after it has run */
  document.addEventListener('DOMContentLoaded', hookTheme);
  window.addEventListener('load', hookTheme);
  if (document.readyState === 'complete') hookTheme();

  /* Initial state: apply the offer code if the cart already qualifies */
  function init() {
    lastMeta = readMeta(document);
    maybeApplyOfferCode(lastMeta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.BMCart = { refresh: refresh, add: addItems, change: changeLine, open: openCart, close: closeCart };
})();
